import styled from "styled-components";
import Modal from "../../components/Modal/Modal";
import { useApp } from "../../contexts";
import { useState } from "react";

const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .description p {
    margin-bottom: 16px;
  }
`;

const getTruncatedEmail = (email, startChars = 1, endChars = 3) => {
  if (!email) return "";
  const [localPart, domainPart] = email.split("@");
  if (!localPart || !domainPart) return email;
  if (localPart.length <= startChars + endChars + 3) {
    return `${localPart}@${domainPart}`;
  }
  const truncated = `${localPart.slice(0, startChars)}***${localPart.slice(-endChars)}`;
  return `${truncated}@${domainPart}`;
};

export const ChangePasswordConfirm = ({
  onClose,
  email,
  otpCooldown,
  allowSendCode,
  onResend,
  onSubmit,
  errorText,
  isLoading,
}) => {
  const { T } = useApp();
  const [otp, setOtp] = useState("");

  const truncatedEmail = getTruncatedEmail(email);

  const handleClose = () => {
    if (onClose && onClose instanceof Function) {
      onClose();
    }
  }

  const handleResendCode = () => {
    if (!allowSendCode) return;
    
    if (onResend && onResend instanceof Function) {
      onResend();
    }
  }

  const canSubmit = () => {
    if (!otp) {
      return false;
    }
    if (otp.length < 6) {
      return false;
    }
    if (isLoading) {
      return false;
    }
    return true;
  }

  const handleInputOtp = (e) => {
    setOtp(e.target.value);
  };

  return (
    <Modal onClose={handleClose}>
      <Modal.ModalBg2 onClose={handleClose} />
      <Modal.Container2 width="850px" onClose={handleClose}>
        <ContentWaper>
          <div
            className="text-black text-center font-semibold text-[24px] 
            xls:text-[30px] tracking-[-0.96px] lg:h-full"
          >
            {T("Email Verification")}
          </div>
          <div className="mt-[10px]">
            <div className="pt-3">
              <div className="flex justify-between gap-4">
                <div>
                  <div className="font-[700] text-[13px]">
                    {T("Verification code sent to email")}
                  </div>
                  <div className="font-[400] text-[15px] italic">
                    {truncatedEmail}
                  </div>
                </div>
                {
                  !allowSendCode ? (
                    <div className="text-[#F12E11] font-[500] text-[28px]">
                      {`${otpCooldown ?? '180'}s`}
                    </div>
                  ) : (
                    <div className="text-[#F12E11] font-[500] text-[13px] cursor-pointer"
                      onClick={handleResendCode}
                    >
                      {T("Resend")}
                    </div>
                  )
                }
              </div>

              <div className="mt-7 mb-6 lg:mb-[25px]">
                <label
                  htmlFor="form_confirm_2fa"
                  className="block text-suzu-gray-9 w-full mb-1 text-[15px] lg:text-base"
                >
                  {T("Verification Code")}
                  <span className="ml-[1px] text-red-600">*</span>
                </label>
                <div className="w-full p-[1px] rounded-[10px] relative border border-black">
                  <input
                    id="form_confirm_2fa"
                    type="text"
                    className="h-[52px] w-full lg:max-w-full px-5 py-3
                        bg-white rounded-[10px]  text-black input-gradient"
                    maxLength={6}
                    placeholder={"••••••"}
                    onInput={handleInputOtp}
                  />
                </div>
                {errorText && (
                  <p className="text-suzu-error text-sm mt-1">
                    {errorText ?? ""}
                  </p>
                )}
              </div>

              <div
                className="mt-[30px] mb-[20px] md:mb-[10px] flex flex-wrap flex-col-reverse 
                md:flex-row md:flex-nowrap justify-center items-center gap-[20px]"
              >
                <button
                  type="button"
                  disabled={!canSubmit()}
                  className="bg-black leading-[52px] !text-white 
                    rounded-[15px] min-w-[231px] w-full md:w-auto px-[20px] h-[52px]
                    disabled:opacity-70 disabled:cursor-not-allowed"
                  onClick={() => onSubmit(otp)}
                >
                  {T("Submit")}
                </button>
              </div>
            </div>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
